import { Component, OnInit , AfterViewInit, OnDestroy} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/authentication/auth.service';
import { Usuario } from 'src/app/authentication/interfaces/interfaces';
import { OrdenesService } from 'src/app/services/transacciones/ordenes.service';
import { Menu, NavService } from '../../services/nav.service';
import { SidebarRightService } from '../../services/sidebar-right.service';
import { SwitcherService } from '../../services/switcher.service';
import { ToastrService } from 'ngx-toastr';

interface MobileMenuItem {
  title: string;
  path: string;
  icon: string;
  activeRoutes: string[];
}

interface MobileTopEntry {
  title: string;
  type: 'link' | 'sub';
  icon: string;
  representativePath: string;
  activeRoutes: string[];
  children: MobileMenuItem[];
}

interface MobileMoreGroup {
  title: string;
  items: MobileMenuItem[];
}
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {

  layoutSubscription: Subscription;
  navSubscription?: Subscription;
  routerSubscription?: Subscription;
  public isCollapsed = true;
  private _usuario!: Usuario;
  public foto!: string;
  public nombre!:string;
  public perfil!:string;
  public sucursal!:string;
  public idUsuario!:string;
  public nombreSucursal!:string;
  public isMobile = window.innerWidth < 992;
  public mobilePrimaryItems: MobileMenuItem[] = [];
  public mobileMoreGroups: MobileMoreGroup[] = [];
  private rawMenuItems: Menu[] = [];
  private readonly PERM_REPORTE_VENTAS = 'transacciones.reportes.ventas';
  private readonly PERM_REPORTE_ENVIO = 'transacciones.reportes.envio';
  constructor(
    private sidebarRightservice: SidebarRightService,
    public navServices: NavService,
    public SwitcherService: SwitcherService,
    private authService: AuthService,
    private router: Router,
    private modalService: NgbModal,
    private ordenesService: OrdenesService,
    private toastr: ToastrService,
  ) {
    this.layoutSubscription = sidebarRightservice.changeEmitted.subscribe(
      direction => {
        const dir = direction.direction;

      }
    )
    this._usuario = authService.loginUsuario;
  }

  ngOnInit(): void {
   

    let foto =  this._usuario.foto || 'vistas/img/usuarios/kevin/211.jpg';

    this.foto = foto;
    this.nombre = this._usuario.nombre!;
    this.perfil = this._usuario.perfil!;
    this.sucursal = this._usuario.sucursal!;
    this.idUsuario = this._usuario.idUsuario!;
    this.nombreSucursal = this._usuario.nombreSucursal!;
    this.syncViewportState();
    this.initializeMobileMenu();

    window.addEventListener('resize', this.onViewportResize);
  }

  toggleSwitcher() {
    this.SwitcherService.emitChange(true);
  }

  toggleSidebarNotification() {
    this.sidebarRightservice.emitSidebarNotifyChange(true);
  }
  toggleSidebarOpen(){
    this.navServices.collapseSidebar = true;

    const body = document.body;
    body.classList.add('sidenav-toggled');
    body.classList.add('sidebar-gone');
    body.classList.add('sidebar-mini');

    if (window.innerWidth < 992) {
      body.classList.add('mobile-menu-open');
    }
  }
  toggleSidebarClose(){
    this.navServices.collapseSidebar = true;

    const body = document.body;
    body.classList.remove('sidenav-toggled');
    body.classList.remove('sidenav-toggled-open');
    body.classList.remove('mobile-menu-open');
  }

  search(){
    let navabarForm:any = document.querySelector('.navbar-form ')
    navabarForm.classList.toggle('d-none')
  }
  close(){
    let navbarD:any = document.querySelector('.navbar-form ')
    navbarD.classList.add('d-none')
  }

  ngAfterViewInit(){
    
   


  }

  SearchActive = "Notactive" 
  searchClass(item:any){
    // this.SearchActive=="nonactive"? "active":"nonactive"
    console.log(item);
    if (item=="active") {
      this.SearchActive = "active"
    }
    if (item=="Notactive") {
      this.SearchActive = "Notactive"
    }
  }

  logout() {
    this.router.navigateByUrl('/login');
    this.authService.logout();
  }

  get canVerMenuReportes(): boolean {
    return this.authService.hasAnyPermission([
      this.PERM_REPORTE_VENTAS,
      this.PERM_REPORTE_ENVIO
    ]);
  }

  get canVerReporteVentas(): boolean {
    return this.authService.hasPermission(this.PERM_REPORTE_VENTAS);
  }

  get canVerEnvioReporte(): boolean {
    return this.authService.hasPermission(this.PERM_REPORTE_ENVIO);
  }

  generarReporte(){
    const pdfWindow = window.open('', '_blank');
    this.ordenesService.generarReporteVentas(
      localStorage.getItem('token'),
      this.sucursal,
      this.nombreSucursal,
      this.nombre
    ).subscribe({
      next: (blob) => {
        const url = URL.createObjectURL(blob);
        if (pdfWindow) {
          pdfWindow.location.href = url;
        } else {
          window.open(url, '_blank');
        }
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      },
      error: (err) => {
        pdfWindow?.close();
        this.toastr.error(
          err?.error?.message || err?.message || 'No se pudo generar el reporte de ventas',
          'Atención',
          { timeOut: 8000, closeButton: true, progressBar: true }
        );
      }
    });
  }

  verInformacion(basicModal:any) {

    this.modalService.open(basicModal);
   
  }

  enviarReporte() {
    
    this.toastr.info("Se está procesando el envío por favor espere", 'Atención', {
      timeOut: 10000,
      closeButton: true,
      progressBar: true
    });
    this.ordenesService.enviarReporteWS(
      localStorage.getItem('token'),
      this.sucursal,
      this.nombreSucursal,
      this.nombre
    ).subscribe((resp) => {

        if(resp == "ok"){

          this.toastr.success("Reporte de ventas enviado correctamente", 'Atención', {
            timeOut: 5000,
            closeButton: true,
            progressBar: true
          });
          
        }
     }, (err) => {
       console.warn('request_error_suppressed', err);
     })
 
   
  }

  esRutaActiva(ruta: string): boolean {
    return this.router.url.startsWith(ruta);
  }

  esMenuMovilActivo(item: MobileMenuItem): boolean {
    return item.activeRoutes.some((ruta) => this.esRutaActiva(ruta));
  }

  get mostrarMasMovil(): boolean {
    return this.mobileMoreGroups.some((group) => group.items.length > 0);
  }

  private syncViewportState() {
    this.isMobile = window.innerWidth < 992;
  }

  private initializeMobileMenu(): void {
    this.navSubscription = this.navServices.items.subscribe((menuItems: Menu[]) => {
      this.rawMenuItems = this.cloneMenuTree(Array.isArray(menuItems) ? menuItems : []);
      this.rebuildMobileMenu();
    });

    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.rebuildMobileMenu();
      }
    });
  }

  private rebuildMobileMenu(): void {
    const filteredTree = this.filterMenuTree(this.cloneMenuTree(this.rawMenuItems));
    const topEntries = this.buildTopEntries(filteredTree);
    const preferredMainPaths = [
      '/sistema/inicio',
      '/sistema/crear-orden',
      '/sistema/ordenes-fisicas-solicitudes'
    ];

    const selectedMain: MobileTopEntry[] = [];
    const selectedPathSet = new Set<string>();

    for (const preferredPath of preferredMainPaths) {
      const found = topEntries.find((entry) => entry.representativePath === preferredPath);
      if (found && !selectedPathSet.has(found.representativePath) && selectedMain.length < 3) {
        selectedMain.push(found);
        selectedPathSet.add(found.representativePath);
      }
    }

    for (const entry of topEntries) {
      if (selectedMain.length >= 3) {
        break;
      }
      if (!selectedPathSet.has(entry.representativePath)) {
        selectedMain.push(entry);
        selectedPathSet.add(entry.representativePath);
      }
    }

    this.mobilePrimaryItems = selectedMain.map((entry) => ({
      title: this.normalizePrimaryTitle(entry.representativePath, entry.title),
      path: entry.representativePath,
      icon: this.normalizePrimaryIcon(entry.representativePath, entry.icon),
      activeRoutes: entry.activeRoutes
    }));

    this.mobileMoreGroups = this.buildMoreGroups(topEntries, selectedPathSet);
  }

  private buildMoreGroups(topEntries: MobileTopEntry[], selectedPathSet: Set<string>): MobileMoreGroup[] {
    const groups: MobileMoreGroup[] = [];
    const generalItems: MobileMenuItem[] = [];

    for (const entry of topEntries) {
      if (entry.type === 'sub') {
        const items = entry.children.filter((child) => !selectedPathSet.has(child.path));
        if (items.length > 0) {
          groups.push({ title: entry.title, items });
        }
        continue;
      }

      if (!selectedPathSet.has(entry.representativePath)) {
        generalItems.push({
          title: entry.title,
          path: entry.representativePath,
          icon: entry.icon,
          activeRoutes: entry.activeRoutes
        });
      }
    }

    if (generalItems.length > 0) {
      groups.push({ title: 'General', items: generalItems });
    }

    return groups;
  }

  private buildTopEntries(items: Menu[]): MobileTopEntry[] {
    const result: MobileTopEntry[] = [];

    for (const item of items) {
      if (!item.title) {
        continue;
      }

      if (item.type === 'link' && item.path) {
        result.push({
          title: item.title,
          type: 'link',
          icon: this.iconFromMenu(item),
          representativePath: item.path,
          activeRoutes: [item.path],
          children: []
        });
        continue;
      }

      if (item.type === 'sub' && item.children && item.children.length > 0) {
        const childLinks = this.collectLinkChildren(item.children);
        if (!childLinks.length) {
          continue;
        }
        result.push({
          title: item.title,
          type: 'sub',
          icon: this.iconFromMenu(item),
          representativePath: childLinks[0].path,
          activeRoutes: childLinks.map((child) => child.path),
          children: childLinks
        });
      }
    }

    return result;
  }

  private collectLinkChildren(items: Menu[] = []): MobileMenuItem[] {
    const children: MobileMenuItem[] = [];
    for (const item of items) {
      if (item.type === 'link' && item.path && item.title) {
        children.push({
          title: item.title,
          path: item.path,
          icon: this.iconFromMenu(item),
          activeRoutes: [item.path]
        });
        continue;
      }
      if (item.children && item.children.length > 0) {
        children.push(...this.collectLinkChildren(item.children));
      }
    }
    return children;
  }

  private iconFromMenu(item: Menu): string {
    const iconMap: { [key: string]: string } = {
      description: 'fe fe-file-text',
      upload_file: 'fe fe-upload',
      business_center: 'fe fe-briefcase',
      admin_panel_settings: 'fe fe-shield',
      home: 'fe fe-home'
    };
    return iconMap[item.icon || ''] || 'fe fe-grid';
  }

  private normalizePrimaryTitle(path: string, defaultTitle: string): string {
    const titleMap: { [key: string]: string } = {
      '/sistema/inicio': 'Inicio',
      '/sistema/crear-orden': 'Órdenes',
      '/sistema/ordenes-fisicas-solicitudes': 'Físicas',
      '/sistema/administracion-solicitud-precios': 'Administración'
    };
    return titleMap[path] || defaultTitle;
  }

  private normalizePrimaryIcon(path: string, defaultIcon: string): string {
    const iconMap: { [key: string]: string } = {
      '/sistema/inicio': 'fe fe-home',
      '/sistema/crear-orden': 'fe fe-file-text',
      '/sistema/ordenes-fisicas-solicitudes': 'fe fe-briefcase',
      '/sistema/administracion-solicitud-precios': 'fe fe-shield'
    };
    return iconMap[path] || defaultIcon;
  }

  private canAccessByRole(item: Menu): boolean {
    const usuarioActual = this.authService.loginUsuario || {};
    const currentRole = String(usuarioActual?.perfil || this.perfil || '').trim();
    const currentAnalisis = String(usuarioActual?.analisis || '');
    const hasRbacPermissions = (usuarioActual?.permisos || []).length > 0;

    if (hasRbacPermissions) {
      return true;
    }

    if (!item.role || !item.role.length) {
      return true;
    }
    return item.role.includes(currentRole) || item.role.includes(currentAnalisis);
  }

  private canAccessByPermission(item: Menu): boolean {
    if (!item.permissions || !item.permissions.length) {
      return true;
    }
    return this.authService.hasAnyPermission(item.permissions);
  }

  private filterMenuTree(items: Menu[] = []): Menu[] {
    const result: Menu[] = [];

    for (const item of items) {
      if (!this.canAccessByRole(item) || !this.canAccessByPermission(item)) {
        continue;
      }

      if (item.children && item.children.length > 0) {
        const filteredChildren = this.filterMenuTree(item.children);
        if (item.type === 'sub' && filteredChildren.length === 0) {
          continue;
        }
        item.children = filteredChildren;
      }

      result.push(item);
    }

    return result;
  }

  private cloneMenuTree(items: Menu[] = []): Menu[] {
    return items.map((item) => ({
      ...item,
      children: item.children ? this.cloneMenuTree(item.children) : undefined
    }));
  }

  private onViewportResize = () => {
    this.syncViewportState();
  };

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.onViewportResize);
    this.navSubscription?.unsubscribe();
    this.routerSubscription?.unsubscribe();
    this.layoutSubscription?.unsubscribe();
  }
}
